<template>
  <div class="diy-alerts__item" :class="isAlertActive && 'unread'">
    <div class="diy-alerts__item-wrapper">
      <!-- toggler -->
      <div class="diy-alerts__item-status-toggler">
        <AppButtonIcon icon="" @click="toggleStatus" />
      </div>
      <!-- message -->
      <div class="diy-alerts__item-content" @click="openCard">
        <CardHeader :card="alert.activity.card" />
        <!-- details -->
        <AlertsItemDetails :activity="alert.activity" />
        <!-- footer -->
        <CardSingleCompany :account="alert.activity.card.account" />
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
import Authorization from 'Mixins/Authorization'
import { getCardModalPageName } from 'Router/helpers'
import { getCardTitleSlug } from 'Modules/Card/common/helpers'
// Components
import AppButtonIcon from 'Ui/AppButtonIcon'
import AlertsItemDetails from './AlertsItemDetails'
import CardHeader from 'Modules/Card/common/components/CardHeader'
import CardSingleCompany from 'Modules/Card/CardSingle/components/CardSingleCompany'

export default {
  name: 'AlertsItem',

  props: {
    alert: {
      type: Object,
      required: true,
    },
  },

  components: {
    CardHeader,
    AppButtonIcon,
    CardSingleCompany,
    AlertsItemDetails,
  },

  mixins: [Authorization],

  data() {
    return {
      card: this.alert.activity.card,
    }
  },

  methods: {
    toggleStatus() {
      this.$emit('toggle-status', this.alert)
    },

    openCard(event) {
      if (event.target.nodeName === 'A') return
      EventBus.$emit('close-topbar-modal')
      let route = getCardModalPageName()
      const accountId = this.card.account.id
      const cardSlug = getCardTitleSlug(this.card.title)
      const newPath = `/account/${accountId}/c/${this.card.id}/${cardSlug}`

      // Checking from where the alert has been click: in case the user is not in a route
      // with a card modal child route, we redirect it to the dashboard.
      if (this.isEmployee) {
        if (!route) route = 'dashboard-team-modal'
        this.$router.push({
          name: route,
          params: { card_id: this.card.id, card_title: cardSlug, account_id: accountId },
        })
      } else {
        this.$router.push({
          path: newPath,
        })
      }
    },
  },

  computed: {
    isAlertActive() {
      return this.alert.is_active
    },
  },
}
</script>

<style scoped>
.diy-alerts__item {
  cursor: pointer;
}

.diy-alerts__item:hover {
  filter: brightness(0.975);
}

.diy-alerts__item-wrapper {
  display: grid;
  align-items: flex-start;
  grid-template-columns: auto 1fr;
  position: relative;
  gap: 1.5625rem;
  position: relative;
  padding: 0.625rem;
  border-radius: 3px;
}

.unread > .diy-alerts__item-wrapper {
  background-color: var(--c-secondary-400);
}

.diy-alerts__item-status-toggler .app-button--icon {
  position: relative;
  width: 17px;
  height: 17px;
  border: 1px solid var(--c-gray-500);
  background-color: #fff;
}

.diy-alerts__item-status-toggler .app-button--icon:hover {
  background-color: var(--c-secondary-400);
}

.diy-alerts__item-status-toggler .app-button--icon:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: var(--c-bright-red-500);
  transition: 0.3s var(--transition-cubic-bounce);
  transform: scale(0);
}

.unread .diy-alerts__item-status-toggler .app-button--icon:before {
  transform: scale(0.8);
}

.diy-alerts__item-content {
  border-radius: 6px;
  background-color: var(--c-secondary-300);
  box-shadow: 0 0 6px -2px var(--rgba-primary-400);
  overflow: hidden;
}

.diy-alerts__item:not(.unread) .diy-alerts__item-content {
  background-color: var(--c-secondary-300);
}

.diy-alerts__item-content .card-header {
  padding: 0.625rem 0.625rem;
  margin: 0.625rem 0.625rem;
  border-radius: 3px;
  background-color: #fff;
}

.diy-alerts__item-content .card-header >>> .card-header__heading {
  margin: 0;
}

.diy-alerts__item-content .card-header >>> .card-header__title {
  font-size: 1rem;
  font-weight: 600;
}

.diy-alerts__item-content >>> .card-company {
  margin-bottom: -4px;
}
</style>
